/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Err_Invalid_UsernameInputs */

const vi_user_err_invalid_username = /** @type {(inputs: User_Err_Invalid_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đăng nhập chỉ gồm chữ thường, số và . _ @ + - (ví dụ: ten@congty.vn), dài 3–50 ký tự`)
};

/**

* @param {User_Err_Invalid_UsernameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_err_invalid_username = /** @type {((inputs?: User_Err_Invalid_UsernameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Err_Invalid_UsernameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_err_invalid_username(inputs)
});